import { AUTHOR_GROUPS } from 'zignal-config';

// Matches 'edit/' followed by one or more non-slash characters
const AuthorGroupURLPathEndRegEx = /edit\/[^/]+/;

export const ALL_AUTHOR_GROUP_TARGETS = AUTHOR_GROUPS.map(ag => ({
  type: ag.type,
  value: ag.targetName,
  label: ag.targetLabel
}));

const displayMessage = ({id, type, message}) => Account.notifications.renderItem({id, type, message});

export const displaySuccess = ({id, msg}) => displayMessage({
  id,
  type: 'alert-success',
  message: `<b>Success!</b> ${msg}`
});

export const displayError = ({id, msg, error}) => {
  displayMessage({
    id,
    type: 'alert-danger',
    message: `<b>Error!</b> ${msg}`
  });
  console.error(`${id} - ${msg}`, error);
};

export const generateNextMemberKey = memberKeyList => {
  const lastMemberKeyInt = parseInt(memberKeyList[memberKeyList.length - 1]);
  if (lastMemberKeyInt === NaN) {
    return ['0']; // safety net - should never happen
  }
  const nextMemberKey = lastMemberKeyInt + 1;
  return String(nextMemberKey);
};

export const resetAuthorsTotalCounts = () => ({ author: 0, domain: 0, media_outlet: 0});

export const getAuthorGroupMembersMetaData = authorGroup => {
  const totalCounts = resetAuthorsTotalCounts();
  const usedSelections = [];
  Object.values(authorGroup.members).forEach(member => {
    const count = Array.isArray(member.authors) ? member.authors.length : 0;
    if (count) {
      totalCounts[member.type] += count;
      usedSelections.push(member.value);
    }
  });
  const unUsedTargets = ALL_AUTHOR_GROUP_TARGETS.filter(target => !usedSelections.includes(target.value));

  return { totalCounts, unUsedTargets };
};

export const updateAuthorGroupURLWithId = (id) => {
  const currentPathname = window.location.pathname;
  let newPathname;
  const match = currentPathname.match(AuthorGroupURLPathEndRegEx);
  if (!match) {
    // no id in the URL
    newPathname = currentPathname + `edit/${id}/`;
  } else if (match[0] === `edit/${id}`) {
    return; // same id
  } else {
    newPathname = currentPathname.replace(AuthorGroupURLPathEndRegEx, `edit/${id}`);
  }
  Backbone.history.navigate(newPathname, { trigger: false });
};

export const removeAnyAuthorGroupIdFromURL = () => {
  const currentPathname = window.location.pathname;
  const index = currentPathname.search(AuthorGroupURLPathEndRegEx);
  if (index !== -1) {
    // URL has some id, don't assume it ends with a slash as the user might not have typed it
    const newPathname = currentPathname.substring(0, index);
    Backbone.history.navigate(newPathname, { trigger: false });
  }
};
